<template>
  <b-row>
    <b-col>
      <PaginatedTable :fields="fields" :on-page-change="getGroups" ref="groupsTableRef">
        <template v-slot:cell(action)="{ item }">
          <div class="d-flex align-items-center gap-2">
            <b-button  class="mr-3" :to="{ name: 'ManageGroup', params: { id: `${item.id}` } }">
              {{ t("CHANGE") }}
            </b-button>
            <img
                v-if="isAdmin()"
                :src="iconRemove"
                @click="deleteGroup(item)" :disabled="isDeleting"
                class="clickable"
                alt="icon Remove with X"
            />
          </div>
        </template>
        <template v-slot:cell(location)="{ item }">
          <span v-if="item.location === GroupLocation.IN_HOUSE">{{ t("IN_HOUSE") }}</span>
          <span v-else>{{ item.location }}</span>
        </template>
        <template v-slot:cell(status)="{ item }">
          <span>{{ t(item.status) }}</span>
        </template>
        <template v-slot:cell(title)="{ item }">
          <span>{{ item.title }}</span>
        </template>
        <template v-slot:cell(startEvent)="{ item }">
          <span v-if="item.startEvent">{{ dateFormat(item.startEvent) }}</span>
        </template>
        <template v-slot:cell(endEvent)="{ item }">
          <span v-if="item.endEvent">{{ dateFormat(item.endEvent) }}</span>
        </template>
        <template v-slot:cell(businessName)="{ item }">
          <span>{{ item.businessName }}</span>
        </template>

        <template v-slot:cell(trainers)="{ item }">
          <li v-for="i in item.trainers" :key="i.trainers">
            {{ i }}
          </li>
        </template>
        <template v-slot:cell(groupSize)="{ item }">
          <span v-if="item.numberOfTrainees">{{ item.numberOfTrainees }} /</span>
          <span v-else>0 / </span>
          <span>{{ item.groupSize }}</span>
        </template>
      </PaginatedTable>
    </b-col>
  </b-row>
  <RemoveGroupModal @group-removed="resetGroupsTable"/>
</template>

<script setup>

import EventBus from "../../../util/eventBus";
import {useDateFormat} from "@/mixins/dateFormatMixin2.ts";
import {inject, onBeforeMount, onBeforeUnmount, ref, watch} from "vue";
import {useI18n} from "vue-i18n";

import removeIcon from "@/assets/icon/icon_x.svg";
import RemoveGroupModal from "@/views/components/modals/removeGroupModal.vue";
import {GroupLocation} from "@/model/group-location";
import PaginatedTable from "@/views/components/PaginatedTable.vue";

const auth = inject("auth");
const isDeleting = ref(false)
const {dateFormat} = useDateFormat();

const props = defineProps({
  filterText: {
    type: String,
    default: "",
  },
  filterStatus: {
    type: String,
    default: "PUBLIC",
  },
});

const iconRemove = removeIcon;
const { t, locale } = useI18n();
const axios = inject("axios");
const groupsTableRef = ref(null);

const getGroups = async (params) => {
  params["search"] = props.filterText;
  params["status"] = props.filterStatus;
  params["currentLocale"] = locale.value;
  params["requestTrainers"] = true;

  return await axios.get('/training/groups/search', {params: params});
};

const resetGroupsTable = () => {
  groupsTableRef.value.reset();
};

const deleteGroup = (group) => {
  EventBus.$emit('show-remove-group-modal', group)
};

onBeforeMount(() => {
  EventBus.$on("GROUP_SEARCH", resetGroupsTable);
});

onBeforeUnmount(() => {
  EventBus.$off("GROUP_SEARCH", resetGroupsTable);
});

watch([locale], resetGroupsTable);

const fields = [
  { key: 'translation',  label: t("MODULE"), sortable: true },
  { key: 'title', label: t("TITLE"),  sortable: true },
  { key: 'startEvent', label: t("START"), sortable: true },
  { key: 'endEvent', label: t("END"), sortable: true },
  {key: 'businessName', label: t("SCHOOL"), sortable: true},
  { key: "language", label: t("LANGUAGE"), sortable: true },
  { key: 'trainers', label: t("TRAINER"), sortable: false },
  { key: 'location', label: t("LOCATION"), sortable: true },
  { key: 'status',  label: t("STATUS"), sortable: false },
  { key: 'groupSize',label: t("OCCUPANCY"), sortable: true },
  {key: 'action', label: "", sortable: false  },
  {key: 'action', label: "", sortable: false  },
];

const isAdmin = () => {
  return auth.hasRole("ADMIN");
};
</script>
